import { Box} from "@chakra-ui/react";
import StudentSideBar from "../Components/StudentSideBar";
import PrivateContentLayout from "../Common/PrivateContentLayout";
import ChangePassword from "../Common/ChangePassword";


interface ChangePasswordProps {
  handleLogout: () => void; // Pass the handleLogout function as a prop
}

const ChangePasswordStudent = ({ handleLogout }: ChangePasswordProps) => {
  
  return (
   
    <Box>
        <StudentSideBar />
        <PrivateContentLayout>
        <ChangePassword handleLogout={handleLogout} />
        </PrivateContentLayout>
    </Box>
  );
};

export default ChangePasswordStudent;
